module.exports = __webpack_public_path__ + "img/71.5567bfe6.png";